import React from 'react'
import ConfigurableCutToSize from "../components/cut-to-size/configurable-baths/ConfigurableCutToSize";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import { setIsConfigurableBathEditScreen } from '../store/ui/actions';
import { getCmOrInches, hasImperialUnits } from "../helpers";
import { getLanguage, getLocalizedUrl } from '../store/ui/reducers'
import { getLines } from '../store/cart/reducers'
import { getUserName, getPriceListAtSelectedCenter } from '../store/login/reducers';
import { getSelectedCenter, getSalesOrg, isUsaOrCanada, isOnlyUsa } from '../store/centers/reducers'
import { changeCartLineCutToSize } from '../store/cut-to-size/actions'
import {
    getConfigurableInProgress,
    getConfigurablePlanAcceptanceList
} from '../store/selected-objects/reducers'
import {
    addConfigurableInProgress,
    addConfigurableModifiedList,
    addConfigurablePlanAcceptanceChecked
} from '../store/selected-objects/actions'
import { getConfigurableDrawingList, getMarket } from '../store/cut-to-size/reducers'

const getConfigurableRouteKey = props => {
    const { type = '', model = '', fabricator = '', refcode = '' } = props.match.params

    return [type, model, fabricator, refcode, props.location.search].join('|')
}

const ConfigCutToSizeScreen = props => <ConfigurableCutToSize key={getConfigurableRouteKey(props)} {...props} />

const mapDispatchToProps = (dispatch, ownprops) => {
    return {
        setIsConfigurableBathEditScreen: isOrderHistoryScreen => {
            dispatch(setIsConfigurableBathEditScreen(isOrderHistoryScreen))
        },
        addConfigurableInProgress: (parentRefcode, config) => dispatch(addConfigurableInProgress(parentRefcode, config)),
        addConfigurablePlanAcceptanceChecked: (refcode, checked) => dispatch(addConfigurablePlanAcceptanceChecked(refcode, checked)),
        changeCartLineCutToSize: (lineId, cutToSize) => dispatch(changeCartLineCutToSize(lineId, cutToSize)),
        addConfigurableModifiedList: (refcode, isModified) => dispatch(addConfigurableModifiedList(refcode, isModified)),
        addDeletedConfigurable: (refcode) => dispatch({type: 'ADD_DELETED_CONFIGURABLE_LIST', refcode}),
        addAddedConfigurable: (refcode) => dispatch({type: 'ADD_ADDED_CONFIGURABLE_LIST', refcode}),
    }
}

const mapStateToProps = (state, ownprops) => {
    return {
        locale: hasImperialUnits(state) ? 'en-US' : 'es-ES',
        model: ownprops.match.params.model,
        refcode: ownprops.match.params.refcode,
        type: ownprops.match.params.type,
        fabricator: ownprops.match.params.fabricator,
        units: getCmOrInches(state),
        localizedUrl: routeId => getLocalizedUrl(state, ownprops.intl, routeId),
        configurableInProgress: getConfigurableInProgress(state),
        configurablePlanAcceptanceList: getConfigurablePlanAcceptanceList(state),
        checkoutLines: getLines(state),
        configurableDrawingList: getConfigurableDrawingList(state),
        username: getUserName(state),
        salesOrg: getSalesOrg(state),
        selectedCenter: getSelectedCenter(state),
        priceListAtSelectedCenter: getPriceListAtSelectedCenter(state),
        isUsaOrCanada: isUsaOrCanada(state),
        isOnlyUsa: isOnlyUsa(state),
        localeSelected: getLanguage(state),
        market: getMarket(state)
    }
}

export default injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(ConfigCutToSizeScreen)
)
